var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"error__box"},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"error"},[(message)?_c('div',{staticClass:"error__text"},[_vm._v(" "+_vm._s(message)+" ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }